import { useEffect, useState } from "react";
import {
  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
  TabContent,
  TabPane,
} from "reactstrap";
import { borderData } from "../../Data/UiKitsData/TabsData";
import { TabDatatype } from "../../Types/UiKitsType";
import { H4, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Utils";
import UserProfiles from "../Apps/Users/UserProfiles";
import AttendanceMe from "../Dashboards/Attendance/AttendanceMe";
import ReportingStruct from "../Dashboards/Attendance/ReportingStruct";
import PendingUnlockRequests from "../Dashboards/Attendance/PendingUnlockRequests";
import Inputss from "../Dashboards/Attendance/Inputs";
import Leaves from "../Dashboards/Attendance/Leaves";
import UserExpenses from "../Dashboards/Attendance/UserExpenses";
import UserMtp from "../Dashboards/Attendance/UserMtp";
import Holidays from "../Dashboards/Attendance/Holidays";
import BrandCampaignContainer from "../Dashboards/BrandCampaign/BrandCampaignContainer";
import TargetVsAchievement from "../Reports/TargetVsAchievement";
import CustomTabWebView from "./CustomTabWebView";
import { CustomTabItem, getCustomTabsForModule } from "../../sharedFunctions/customTabs";
import { isSystemConfigEnabled } from "../../sharedFunctions/SystemConfig";

export default function BorderTabContent({
  tabId,
  employeeIdProp,
  tdate,
  positionId,
  customTabs: customTabsProp,
}: {
  tabId: string;
  employeeIdProp?: number;
  tdate?: string;
  positionId?: number;
  customTabs?: CustomTabItem[];
}) {
  const [customTabs, setCustomTabs] = useState<CustomTabItem[]>(customTabsProp || []);

  useEffect(() => {
    if (customTabsProp) {
      setCustomTabs(customTabsProp);
      return;
    }

    let isMounted = true;
    const loadTabs = async () => {
      const tabs = await getCustomTabsForModule('lms');
      if (isMounted) setCustomTabs(tabs);
    };
    loadTabs();

    const handleUpdate = () => {
      loadTabs();
    };
    window.addEventListener('customTabsUpdated', handleUpdate);
    return () => {
      isMounted = false;
      window.removeEventListener('customTabsUpdated', handleUpdate);
    };
  }, [customTabsProp]);

  const borderData: TabDatatype[] = [
    {
      id: "1",
      text: <UserProfiles employeeIdProp={employeeIdProp ?? 1} />,
    },
    {
      id: "2",
      text: employeeIdProp ? (
        <CardBody className="pb-0">
          <div className="main-inbox">
            <AttendanceMe
              employeeIdProp={employeeIdProp}
              tdate={tdate}
              positionId={positionId}
            />
          </div>
        </CardBody>
      ) : (
        <CardBody>
          <p>No employee data available</p>
        </CardBody>
      ),
    },
    {
      id: "3",
      text: (
        <CardBody className="px-0 pb-0">
          <ReportingStruct employee_id={employeeIdProp ?? 0} />
        </CardBody>
      ),
    },
    {
      id: "lock_requests",
      text: (
        <CardBody className="px-0 pb-0">
          <PendingUnlockRequests employeeIdProp={employeeIdProp} />
        </CardBody>
      ),
    },
    {
      id: "4",
      text: (
        <CardBody className="px-0 pb-0">
          <Inputss employeeIdProp={employeeIdProp ?? 0} />
        </CardBody>
      ),
    },
    {
      id: "5",
      text: (
        <CardBody className="px-0 pb-0">
          <Leaves employeeIdProp={employeeIdProp ?? 0}/>
        </CardBody>
      ),
    },
    {
      id: "6",
      text: (
        <CardBody className="px-0 pb-0">
          <UserExpenses employeeIdProp={employeeIdProp ?? 0} />
        </CardBody>
      ),
    },
    {
      id: "7",
      text: (
        <CardBody className="px-0 pb-0">
          <UserMtp employeeIdProp={employeeIdProp ?? 0} positionId={positionId} />
        </CardBody>
      ),
    },
    ...(isSystemConfigEnabled("holiday_approval_enable")
      ? [
          {
            id: "8",
            text: (
              <CardBody className="px-0 pb-0">
                <Holidays employeeIdProp={employeeIdProp ?? 0} positionId={positionId} />
              </CardBody>
            ),
          },
        ]
      : []),
    {
      id: "9",
      text: (
        <CardBody className="px-0 pb-0">
          <BrandCampaignContainer />
        </CardBody>
      ),
    },
    ...(isSystemConfigEnabled("targets_vs_achivements_enabled")
      ? [
          {
            id: "10",
            text: (
              <CardBody className="px-0 pb-0">
                <TargetVsAchievement isTab={true} />
              </CardBody>
            ),
          },
        ]
      : []),
  ];

  return (
    <TabContent activeTab={tabId}>
      {borderData &&
        borderData.map((item, index) => (
          <TabPane
            className={`fade ${tabId === item.id ? "show" : ""}`}
            tabId={item.id}
            key={index}
          >
            {item.text}
          </TabPane>
        ))}

      {/* Dynamic custom tabs */}
      {customTabs &&
        customTabs.map((cTab) => (
          <TabPane
            className={`fade ${tabId === cTab.id ? "show" : ""}`}
            tabId={cTab.id}
            key={cTab.id}
          >
            <CardBody className="px-0 pb-0 pt-2">
              <CustomTabWebView activeTab={cTab} />
            </CardBody>
          </TabPane>
        ))}
    </TabContent>
  );
}
